import React, { useMemo } from "react";
import styled from "styled-components";
import getConfig from "next/config";
import { isMobile } from "react-device-detect";
import { OverlayTrigger, Tooltip, Form } from "react-bootstrap";

const StyledGroup = styled(Form.Group)`
  display: flex;
  flex-direction: column;

  ${({ horizontal }) => horizontal && css`
    flex-direction: row;
  `};

  padding-left: 0;
  padding-right: 0;
  margin-bottom: 16px !important;

  input:checked + label,
  input:not(:checked) + label {
    display: inline-block;
    
    padding-left: 8px;
    font-family: 'InterRegular';
    font-size: 14px;
    line-height: calc(1.42857rem * (14 / 16));
    color: #424242;

    cursor: pointer;
  }
`;

const StyledCheck = styled(Form.Check)`
  margin-right: 24px;
  margin-top: 0.5rem;
`;

function RadioGroup({
  id,
  name,
  hint,
  horizontal,
  options = [],
  value,
  onChange,
}) {
  const overlayTriggerProps = useMemo(() => {
    const props = {
      placement: isMobile ? "top" : "right-start",
      delay: { show: 0, hide: 0 },
      trigger: ["hover", "focus"],
      overlay: (
        <Tooltip id={`tooltip-${id}`} className="hintTooltip">
          {hint}
        </Tooltip>
      ),
    };

    if (!hint || isMobile) {
      props.show = false;
    }

    return props;
  }, [id, hint]);

  return (
    <OverlayTrigger {...overlayTriggerProps}>
      <StyledGroup controlId={id} horizontal={horizontal}>
        {options.map((option, i) => (
          <StyledCheck
            key={`${name ? name : id}${i + 1}`}
            id={`${name ? name : id}${i + 1}`}
            name={name ? name : id}
            inline
            type="radio"
            label={option.label}
            value={option.value}
            checked={value === option.value}
            onChange={onChange}
          />
        ))}
      </StyledGroup>
    </OverlayTrigger>
  );
}

export default RadioGroup;
